module.exports = __webpack_public_path__ + "static/media/object_immotal5.215b2b39.png";